import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CheckboxLabels from './CheckboxLabels';
import ClientProvider from './client';
export default createDemo(import.meta.url, CheckboxLabels, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/checkboxes/demos/labels/CheckboxLabels.tsx",
    "fileName": "CheckboxLabels.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import FormGroup from '@mui/material/FormGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Checkbox from '@mui/material/Checkbox';\n\nexport default function CheckboxLabels() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <FormGroup>\n      <FormControlLabel control={<Checkbox defaultChecked />} label=\"Label\" />\n      <FormControlLabel required control={<Checkbox />} label=\"Required\" />\n      <FormControlLabel disabled control={<Checkbox />} label=\"Disabled\" />\n    </FormGroup>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 13,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import FormGroup from '@mui/material/FormGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Checkbox from '@mui/material/Checkbox';\n\nexport default function CheckboxLabels() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <FormGroup>\n      <FormControlLabel control={<Checkbox defaultChecked />} label=\"Label\" />\n      <FormControlLabel required control={<Checkbox />} label=\"Required\" />\n      <FormControlLabel disabled control={<Checkbox />} label=\"Disabled\" />\n    </FormGroup>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Label",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "required"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Required",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Disabled",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "FormGroup"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 13,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/FormGroup",
      "@mui/material/FormControlLabel",
      "@mui/material/Checkbox"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
